export class GetDataCatalogSemanticLayerArtifactResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "url",
            "baseName": "url",
            "type": "string",
            "format": ""
        },
        {
            "name": "document",
            "baseName": "document",
            "type": "{ [key: string]: any; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetDataCatalogSemanticLayerArtifactResponse.attributeTypeMap;
    }
    constructor() {
    }
}
